module.exports = __webpack_public_path__ + "static/media/SalmonPng.e1ea78f5.png";